import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import { Link } from "./../util/router";
import PoseCard from "./PoseCard";
import { Typography } from "@material-ui/core";
const imageInfo = [

  {
    image: 'poses/boobFlash.jpg',
    title: 'Flashing Boobs',
  },

  
  {
    image: 'https://rule34ai.art/wp-content/uploads/2023/08/Hyuga-Hinata-doggystyle-creampie-608x486.jpg',
    title: 'DoogyStyle',
  },{
    image: 'poses/masturbation.jpg',
    title: 'Masturbation',
  },
  {
    image: 'poses/povAnal.jpg',
    title: 'POV Aanl',
  },
  {
    image: 'poses/titJob.jpg',
    title: 'Tit Job',
  }, {
    image: 'https://prompthero.com/rails/active_storage/blobs/proxy/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaWxtT1RJek1XTXpOQzAwTTJZMExUUTJNRFV0WVdObVpDMHhOelpqT0RFNU56UmxZVE1HT2daRlZBPT0iLCJleHAiOm51bGwsInB1ciI6ImJsb2JfaWQifX0=--f691532595f3462156b5da3c1d4585f949449050/prompthero-prompt-75f06188085.jpeg',
    title: 'BlowJob',
  },
  {
    image: 'https://cdn.truyen-hentai.com/i-made-some-ai-art-of-mikasa-ackerman-source-pix?interlace=1&quality=85&type=jpeg&url=https%3A%2F%2Fpreview.redd.it%2Fudt89mgld8la1.jpg%3Fwidth%3D512%26format%3Dpjpg%26auto%3Dwebp%26v%3Denabled%26s%3D485c5b5ea827382c75e5e91d72a57ec71f00aa9d&width=400&sign=CI3h8VGsaoEeSJpToKGXreG50HIRTvix2nkC6J49jlw',
    title: 'Vagina Spread',
  },
  {
    image: 'poses/blowJobUD.jpg',
    title: 'BlowJob UnderDesk',
  },{
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQMG-ZD6xyGOnsDl5lv4N4rM_LvPlrbX8v9oO3fmEn4IMmvqE9tknWtp4nKO-4wH4dk3x4&usqp=CAU',
    title: 'BUKKAE',
  },
  {
    image: 'https://tbi.sb-cd.com/t/14146158/1/4/w:300/t8-enh/ai-ahegao-lookbook.jpg',
    title: 'Stick Out Tongue',
  },{
    image: 'poses/spitRoast.jpg',
    title: 'Spit Roast',
  },
  {
    image: 'poses/spooning.jpg',
    title: 'Spooning',
  },{
    image: 'poses/breastGrab.jpg',
    title: 'Solo Breast Grab',
  },
  {
    image: 'poses/restingOnBelly.jpg',
    title: 'Resting On Belly',
  },
  {image:"poses/grabAss.jpg",
  title:"Ass Grab"

  },
  {
    image: 'poses/cowGirl2.webp',
    title: 'Cow Girl',
  },
  {
    image: 'poses/reverseCowGirl.png',
    title: 'Reverse Cow Girl',
  },
  // Add more image and title objects as needed
];


const useStyles = makeStyles((theme) => ({
  // Increase <Container> padding so it's
  // at least half of <Grid> spacing to
  // avoid horizontal scroll on mobile.
  // See https://material-ui.com/components/grid/#negative-margin
  
  image: {
    margin: "0 auto",
    display: "block",
    height: "auto",
    width: "100%",
  },
}));
const premiumBenefits2 = [
  "Our platform offers you access to extensive collection of over 10+ diverse poses to apply on our AI art. These poses will help you to widen your imagination spanning from Missionary to  POV, and featuring characters like catgirls and elves. "];
  
  
function HeroSection3(props) {
  const classes = useStyles();
  

  return (
   
      <Container style={{padding:"0px",
       }}>





      <Box  sx={{ flexDirection: { xs: 'column-reverse',lg: 'row-reverse' } }} style={{ display: 'flex', justifyContent: 'space-between', }}>
           {/* left side */}

      <Grid container xs={12} lg={8} style={{maxHeight:"700px",overflow:"auto"}} >
      {imageInfo.map((info, index) => (
                <Grid
                  item
                  xs={6}sm={3} lg={4}
                  style={{
                    width: 'fit-content',
                    height: 'auto',
                    display: 'flex',
                    position:"relative",
                    alignItems: 'center',
                    margin:"5px 0px"
                  }}
                  key={index}
                >
                
                <PoseCard key={index} image={info.image}                    bottom={index%2 === 0 ? null : 20}
 title={info.title} />
 
                </Grid>
              ))}
</Grid>

       {/* right side */}
       <Grid container xs={12} lg={6} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',  borderRadius: 8,
 }}> 
  <Box>

  
    <Box
  id="right"
  sx={{
    display: { xs: "flex", sm: "flex", md: "flex" },justifyContent: "space-evenly",
    flexDirection: "column-reverse",
  }}
>
          <Box
            sx={{
              flexDirection: "column",
              gap: "6px",
            }}
          >
            <Box>
 <Box  sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "5px",

                  borderRadius:"0px 20px 0px 20px",  maxWidth:"100%"

                }}
              >
                 
    <Typography variant="h3"  style={{fontWeight:"500", fontFamily:" Chakra Petch, sans-serif",fontSize:"30px"}} >
    Explore a Variety of Sensual Poses</Typography>
                {/* Premium Benefits List */}
                {premiumBenefits2.map((benefit, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      flexDirection: "row",

                    }}
                    style={{  padding: "6px" }}

                  >
                  
                  <Typography
                      variant="body2"

                      sx={{
                        color: "white",
                        fontSize: "sm",
                        fontWeight: "medium",
                        lineHeight: "tight", 
                        
                      }}
                      style={{fontFamily:"Chakra Petch, sans-serif",fontSize:"18px",
                    
                    }}
                    >
                      {benefit}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box style={{display:"flex", justifyContent:"flex-start",gap:"10px"}}>
       <Button   component={Link}
        to="/create" variant="contained" style={{background:"#6600FF",color:"white"}}>Try Now</Button>
<Button variant="outlined"   component={Link}
        to="/about">Learn More</Button>
       </Box>
          </Box>
          <Box
            sx={{
              display:{sm:"none",lg:"block"},
              position:"relative",
              textAlign: "center",
            }}
          >
            <img
              src="homePage/featureImage3.png"
              alt="Manga"
              style={{ width: "65%",minWidth:"300px", objectFit: "cover" }}
            />
          </Box>
         </Box>
  </Box>
  </Grid>
  </Box>
  





























      </Container>
  );
}

export default HeroSection3;

// bottom={index % 2 === 0 ? null : 20}
